import React, { Component } from 'react'
import { AddNewCallDiv, AvatarDiv, BreakBar, OnlineBtn, AvatarBreakDiv } from '../styles/dialpadstyle'
import { Button } from 'modules/theme'

export class CallBreakSelectTheme extends Component {
    render() {
        const { breakImg, breakName, breakText, breakTime, ButtonText, OnClickEvent } = this.props;
        return (
            <span style={{display: 'block', width: '100%'}}>
                <AddNewCallDiv>
                    <BreakBar>
                        <AvatarBreakDiv>
                            <img src={breakImg} />
                        </AvatarBreakDiv>
                        <h4>{breakName}</h4>
                        <h6>{breakText}</h6>
                        <h5>{breakTime}</h5>
                    </BreakBar>
                </AddNewCallDiv>
                <OnlineBtn>
                    <Button btnStyle="simple" size="small" onClick={OnClickEvent}>
                        {ButtonText}
                    </Button>
                </OnlineBtn>
            </span>
        )
    }
}

export default CallBreakSelectTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallBreakSelectTheme.js